import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'
import CommentModel from './comment'
import lodash from 'lodash'

export default class ThreadModel extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }
    writable

    get comments(): Array<CommentModel> {
        return this._relationships['comments'] ? this._relationships['comments'] : []
    }

    set comments(comments: Array<CommentModel>) {
        Vue.set(this._relationships, 'comments', lodash.uniqBy(comments, '_id'))
    }

    async getComments(
        filters,
        include = ['thread', 'parent', 'createdBy', 'reactions.user', 'attachments']
    ) {
        let query = {
            filters,
            include,
        }
        let res = await Vue.prototype.$vbit.get('comment', 'comments', query)
        let comments = res.data.reverse().map((item) => new CommentModel(item, res.included))
        this.comments = [...comments, ...this.comments]
        return comments
    }

    static async get(threadId: string) {
        let res = await Vue.prototype.$vbit.get('comment', `threads/${threadId}`)
        return new ThreadModel(res.data, res.included)
    }

    async postComment(
        body,
        include = ['thread', 'parent', 'createdBy', 'reactions.user', 'attachments']
    ) {
        let query = {
            include: include,
            body: {
                data: {
                    type: 'comment',
                    attributes: {
                        body: body,
                    },
                    relationships: {
                        thread: {
                            data: {
                                id: this._id,
                                type: this._type,
                            },
                        },
                    },
                },
            },
        }
        let res = await Vue.prototype.$vbit.post('comment', `comments`, query)

        let comment = new CommentModel(res.data, res.included)

        this.comments = [...this.comments, comment]
        return comment
    }
}
